import api from "../../../services/apiClient"
import type { DocumentFormValues } from "../models/document"
import { fileToBase64 } from "../../../helpers/fileToBase64"

const BASE = "document"

function buildPayload(values: DocumentFormValues & { file?: File | null }): Record<string, unknown> {
  return {
    category_id: values.category_id,
    description: values.description,
    public: values.public,
    valid_until: values.valid_until || null,
    rules: values.rules,
  }
}

export const documentApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },

  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },

  create: async (values: DocumentFormValues & { file?: File }) => {
    const payload = buildPayload(values)
    if (values.file) {
      payload.file = await fileToBase64(values.file)
      payload.file_name = values.file.name
      payload.mime_type = values.file.type
    }
    const { data } = await api.post(`${BASE}/create`, payload)
    return data?.data ?? data
  },

  update: async (id: number, values: DocumentFormValues & { file?: File | null }) => {
    const payload = buildPayload(values)
    if (values.file) {
      payload.file = await fileToBase64(values.file)
      payload.file_name = values.file.name
      payload.mime_type = values.file.type
    }
    const { data } = await api.post(`${BASE}/update/${id}`, payload)
    return data?.data ?? data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },

  getCategories: async () => {
    const { data } = await api.get(`${BASE}/categories`)
    return data?.data ?? data
  },

  getTypes: async () => {
    const { data } = await api.get(`${BASE}/types`)
    return data?.data ?? data
  },
}
